import LocationFilters from './LocationFilters';

export default LocationFilters;
